window.loadIMG = {
  configNum:1,
  institution: "达达助教",
  systemName: "达达助教教务机构管理系统",
  bgTitle: "让您管理校区更加轻松",
  link: "www.yiqun169.com",
  corporateName: "合肥毅群科技有限公司",
  corporateUser: "余意",
  corporatePhone: "15155913091",
  corporateAddress: "安徽省合肥市经济技术开发区繁华大道1227号",
  salesPhone: "15155913091", //售后电话
  emptyImage: "", //无数据 提示图 不写就不显示
  homePagebg:
    "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/homebg.png", //homepage页背景
  myPagebg:
    "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/homebg.png", //selfpage页背景
  noticIcon:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/notic.png", //homepage 滚动通知栏的小喇叭
  indexIcon:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/tabbar/indexIcon.png", //首页 没选中
  indexIconA:
    "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/homesel.png", //首页选中
  myIcon:
    "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/myunselect.png", // 我的 没选中
  myIconA:
    "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/myselect.png", //我的 选中

  bgimg: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/mybg.png", //我的页面  学员详情 的背景
  bgimg1: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/hsbg.png", //充值页面  的背景

  backgroundImage:
    "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/login.png", //登录页背景

  aboutmeImg: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/logo3.png", //关于我们 logo

  qrCode:
    "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/teachercode.png", //我的页面 二维码
  bluePen: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/edit.png", //我的页面编辑按钮
  tjyj: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/tuijian.png", //我的 推荐有奖
  yjfk: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/yijian.png", // 我的 意见反馈
  gywm: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/about.png", // 我的 关于我们
  zxzh: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/out.png", // 我的 注销账号

  moreIcon: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/more.png", //首页 更多

  boy: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/boy.png", //男生
  girl: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/girl.png", //女生
  youArrow: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/right.png",
  registerbg:
    "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/rebg.png", //注册页
  refreshBtn:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/refreshBtn.png",
  arrowDm:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/arrowDm.png",
  jwsj: [
    { name: "1", label: "授课统计" },
    { name: "0", label: "数据概况" }
    // { name: "dayData2", label: "课消统计" },
  ],
  zssj: [
    { name: "2", label: "招生排名" },
    { name: "1", label: "招生趋势" },
    { name: "0", label: "数据概况" }
  ],
  xssj: [
    { name: "1", label: "销售额分析" },
    { name: "2", label: "销售额月统计" },
    { name: "0", label: "数据概况" }
  ],
  status1: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/status1.jpg",
  status2: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/status2.jpg",
  status3: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/status3.jpg",
  blackPanel:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/blackPanel.png",

  confirmButtonColor: "#ff4210"
};



// WEBPACK FOOTER //
// ./src/style_dd/loadimage.js